import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/Home/components/RecommenderCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/Home/components/ScrollToTopButton.tsx");
